import React, { useState, useEffect } from 'react';
import ProductList from './forms/ProductList';
import DataForm from './forms/DataForm';
import ContactForm from './forms/ContactForm';
import axios from 'axios';
import { useLocation, useSearchParams } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import KundenstreckeParentForm from './forms/kundenstrecke/KundenstreckeParentForm';
import PathChoiceForm from './forms/PathChoiceForm';
import {Login, isLoggedIn} from './forms/Login';
import {ValidationProvider} from './custom_elements/ValidationContext';

// Access the global domain based on the environment
const backendUrl = process.env.REACT_APP_DOMAIN_BACKEND; // Get domain from environment variable
const domain = process.env.REACT_APP_DOMAIN_WORDPRESS; // Get domain from environment variable

const MainContainer = () => {

  const [searchParams, setSearchParams] = useSearchParams();
  const [showContactForm, setShowContactForm] = useState(false);
  const [showKundenForm, setShowKundenForm] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);

  const [requestData, setRequestData] = useState({
    kaufpreis: searchParams.get('kaufpreis') || "",
    laufzeit: searchParams.get('laufzeit') || "420",
    vorhaben: searchParams.get('vorhaben') || "2",
    eigenmittel: searchParams.get('eigenmittel') || "",
    from: searchParams.get('from'),
  });

  useEffect(() => {
    const saveReferrer = async () => {
      console.log("INSIDE SAVE REFERRER");
      const referrer = document.referrer;

      // Check if the referrer exists and isn't already saved
      const isReferrerSaved = localStorage.getItem('referrerSaved');
      const data = { referrer: referrer, from: requestData.from };
      if ((!isReferrerSaved) && requestData.from && !referrer.includes(window.location.hostname)) {
        console.log("SAVING REFERRER..");
        try {
          const apiUrl = `${backendUrl}/ajaxController.php?action=saveReferrer`;

          const response = await axios.post(apiUrl, data);
          // Mark referrer as saved locally
          localStorage.setItem('referrerSaved', 'true');
          console.log("REFERRER_ID: ", response.data);
          localStorage.setItem('referrerId', response.data);
        } catch (error) {
          console.error('Error saving referrer:', error);
        }
      }
    };

    saveReferrer();
  }, []);

  const [product, setProduct] = useState([]);

  const toggleContactForm = (chosen_product) => {
    setShowContactForm(!showContactForm);
    setProduct(chosen_product);
  };

  const handleLogin = () => {
    console.log('login');
    setLoggedIn(isLoggedIn());
};

  const handleBerechnenButton = (data) => {
      setRequestData(data);
      console.log(requestData);
  }

  return (
    <main className="container py-4 main-content">

      <ValidationProvider>
      {showContactForm ?
            <PathChoiceForm product={product} onBackClick={toggleContactForm}></PathChoiceForm>
              :<ProductList onBerechnenButton={handleBerechnenButton} onButtonClick={toggleContactForm} 
              passedRequestData={requestData}/>

      }
      </ValidationProvider>
{/*
      {!loggedIn &&
       <Login onLogin={handleLogin} />}

      
      {loggedIn && <KundenstreckeParentForm /> }
      <ValidationProvider>
        <KundenstreckeParentForm />
      </ValidationProvider>
      <PathChoiceForm product={product} onBackClick={toggleContactForm}></PathChoiceForm>*/}


    </main>
  );
};

export default MainContainer;
